module.exports = __webpack_public_path__ + "24e004ab/img/placeholder.888fcd0b.svg";